import React, { createContext, useContext, useState } from "react";
import { PollContextProviderComponent } from "./poll";
import { SessionContextProviderComponent } from "./session";

export const CustomModalContext = createContext<{
    customModal?: JSX.Element;
    openCustomModal: (modal: JSX.Element) => void;
    closeCustomModal: () => void;
}>({
    customModal: undefined,
    openCustomModal: () => {},
    closeCustomModal: () => {},
});

export function CustomModalProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const [customModal, setCustomModal] = useState<JSX.Element | undefined>(
        undefined,
    );
    const [visible, setVisible] = useState(false);

    const openCustomModal = (modal: JSX.Element) => {
        setCustomModal(modal);
        setVisible(true);
    };

    const closeCustomModal = () => {
        setVisible(false);
        setTimeout(() => {
            setCustomModal(undefined);
        }, 500);
    };

    return (
        <CustomModalContext.Provider
            value={{ customModal, openCustomModal, closeCustomModal }}
        >
            {children}
            {customModal !== undefined && (
                <SessionContextProviderComponent>
                    <PollContextProviderComponent>
                        <div
                            className={`custom-modal-container ${visible ? "visible" : ""}`}
                        >
                            {customModal}
                        </div>
                    </PollContextProviderComponent>
                </SessionContextProviderComponent>
            )}
        </CustomModalContext.Provider>
    );
}

export const useCustomModal = () => useContext(CustomModalContext);
